var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.5,
    rx: 15,
    ry: 14.5,
    fill: "#2CB0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0226 21.2968C18.9052 21.2973 18.7893 21.2696 18.6848 21.2161L14.9395 19.2553L11.1942 21.2161C11.0725 21.28 10.9354 21.3086 10.7984 21.2985C10.6614 21.2884 10.5299 21.24 10.419 21.1589C10.3081 21.0778 10.2221 20.9672 10.1709 20.8397C10.1197 20.7122 10.1053 20.5729 10.1293 20.4376L10.8637 16.3031L7.83807 13.3656C7.74367 13.2714 7.67671 13.1533 7.64436 13.0239C7.61202 12.8945 7.61551 12.7588 7.65448 12.6312C7.69704 12.5007 7.77534 12.3847 7.88048 12.2965C7.98562 12.2082 8.1134 12.1512 8.24932 12.1318L12.4353 11.5223L14.2785 7.75497C14.3387 7.63081 14.4326 7.52609 14.5495 7.45283C14.6664 7.37956 14.8015 7.3407 14.9395 7.3407C15.0774 7.3407 15.2126 7.37956 15.3295 7.45283C15.4464 7.52609 15.5403 7.63081 15.6004 7.75497L17.4657 11.515L21.6517 12.1245C21.7876 12.1438 21.9154 12.2008 22.0205 12.2891C22.1256 12.3774 22.2039 12.4934 22.2465 12.6239C22.2855 12.7514 22.289 12.8872 22.2566 13.0165C22.2243 13.1459 22.1573 13.264 22.0629 13.3582L19.0373 16.2957L19.7717 20.4303C19.7979 20.568 19.7842 20.7103 19.7321 20.8404C19.6801 20.9705 19.5919 21.083 19.4779 21.1647C19.3449 21.2578 19.1848 21.3043 19.0226 21.2968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.70738fdca5c04906aeb20b0670cec2ec.svg";
export { ForwardRef as ReactComponent };